<template>
    <el-form ref="adForm" :model="adForm" :rules="adFormRules" labelWidth="80px" size="medium">
        <el-form-item prop='language' label='语言'>
            <el-select v-model="adForm.language" placeholder="请选择语言" clearable>
                <el-option label="中文" value="cn"></el-option>
                <el-option label="英文" value="en"></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="类型：" prop="type">
            <el-select v-model="adForm.type" placeholder="请选择类型">
                <el-option label="banner" value="banner" selected></el-option>
            </el-select>
        </el-form-item>
        <el-form-item label="标题：" prop="title">
            <el-input v-model="adForm.title" placeholder="请输入标题" clearable></el-input>
        </el-form-item>
        <el-form-item label="描述：" prop="brief">
            <el-input v-model="adForm.brief" placeholder="请输入描述" clearable></el-input>
        </el-form-item>
        <el-form-item label="图片：" prop="img">
            <el-upload
                class="cover-uploader"
                action="https://ecogreenweb.icangjiang.com/upload/upyun"
                :show-file-list="false"
                :on-success="handleAvatarSuccess">
                <img v-if="adForm.img" :src="adForm.img" class="cover-img">
                <i v-else class="el-icon-plus cover-uploader-icon"></i>
            </el-upload>
            <p class="tips_img">图片建议尺寸：1920*990</p>
        </el-form-item>
        <el-form-item label="链接：" prop="url">
            <el-input v-model="adForm.url" placeholder="请输入链接" clearable></el-input>
        </el-form-item>
        <el-form-item label="排序：" prop="weigh">
            <el-input v-model="adForm.weigh" placeholder="请输入排序" clearable></el-input>
        </el-form-item>
        <el-form-item label="是否开启" prop='status'>
            <el-switch
                v-model="adForm.status"
                active-value="active"
                inactive-value="unactive">
            </el-switch>
        </el-form-item>
    </el-form>
</template>

<script>
    export default {
        name: "adEdit",
        props:["adForm"],
        data(){
            return{
                adFormRules:{
                    language: [
                        { required: true,message: '请选择语言',trigger: 'change'}
                    ],
                    type:[
                        { required: true, message: '请选择类型', trigger: 'change' }
                    ],
                    title:[
                        {required:true,message:"请输入标题",trigger:"blur"}
                    ],
                    img:[
                        {required:true,message:"请上传图片",trigger:"blur"}
                    ]
                }
            }
        },
        mounted(){},
        methods:{
            handleAvatarSuccess(res) {
                this.$set(this.adForm,'img',res.data.url);
            },
        }
    }
</script>

<style scoped>
    /* 广告图上传 */
    .cover-uploader >>> .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .cover-uploader >>> .el-upload:hover {
        border-color: #409EFF;
    }
    .cover-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 240px;
        height: 135px;
        line-height: 135px;
        text-align: center;
    }
    .cover-img {
        width: 240px;
        height: 135px;
        display: block;
    }
    .tips_img{
        line-height:20px;
        
    }
</style>